import { AddressHelper } from '@/helpers/addressHelper';
import { PropertyHelper } from '@/helpers/property.helper';
import { UserHelper } from '@/helpers/user.helper';
import { EEMO_ICON_KEY } from '@/modules/icon-eemo-module/enums/eemo-icon.enums';
import { NgFor, NgIf } from '@angular/common';
import { AfterContentInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import {
  PhotosService,
  PropertiesService,
  RealProperty,
  RealPropertySummaryChild,
  VaultService
} from '@eemo/api-client';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { IRealProperty } from '../property-list/property-list.component';

@Component({
  selector: 'app-property-details',
  templateUrl: './property-details.component.html',
  styleUrls: ['./property-details.component.scss'],
  standalone: true,
  imports: [MatIconModule, NgIf, NgFor, TranslateModule]
})
export class PropertyDetailsComponent implements OnInit, OnDestroy, AfterContentInit {
  @Input() property: IRealProperty;
  @Input() highestAncestor?: RealProperty; // the highest ancestor
  @Input() condoMode = false;

  subs: Subscription[] = [];
  EEMO_ICON_KEY = EEMO_ICON_KEY.EEMO;

  nbAttribute: number | null = null;
  nbPhoto: number | null = null;
  nbDoc: number | null = null;
  parentName: string | null = null;
  childs: RealPropertySummaryChild | null = null;

  keyTranslateNbAttr = '';
  keyTranslateNbPhoto = '';
  keyTranslateNbDoc = '';

  nbAttrParams: any;
  nbPhotoParams: any;
  nbDocParams: any;
  parentParams: any;

  childrenDisplay: string[] = [];
  addressDisplay: string;

  constructor(
    private propertyService: PropertiesService,
    private translate: TranslateService,
    private photosService: PhotosService,
    private vaultService: VaultService,
    private userHelper: UserHelper,
    private propertyHelper: PropertyHelper
  ) {}

  ngOnInit(): void {
    // if ongoing selling and viewing mode we show only the city
    if (this.propertyHelper.isOnSelling(this.property) && !this.userHelper.canUpdateProperty(this.property)) {
      this.addressDisplay = this.propertyHelper.getAddressCityName(this.property.address);
    } else {
      this.addressDisplay = AddressHelper.getFullAddress(this.property.address);
    }
    this.loadData();
  }

  ngOnDestroy(): void {
    this.subs.forEach((s) => s.unsubscribe());
  }

  ngAfterContentInit(): void {
    this.parentParams = { parentName: this.property?.parent?.name, type: '' };
    this.childrenDisplay =
      this.property?.children.map((c) => c.name + ' (' + this.translate.instant('enum.PropertyType.' + c.type) + ')') ||
      [];
  }

  // ---------------------------------------- //
  //                   APIS                   //
  // ---------------------------------------- //
  loadData() {
    this.subs.push(
      this.propertyService.getRealPropertyAttributes(this.property.uid, null, null).subscribe((data) => {
        this.nbAttribute = data.length;
        this.keyTranslateNbAttr = this.nbAttribute < 2 ? 'propertyDetails.nbAttribute' : 'propertyDetails.nbAttributeS';
        this.nbAttrParams = { nb: this.nbAttribute };
      })
    );

    this.subs.push(
      this.photosService.getRealPropertyPhotos(this.property.uid).subscribe((data) => {
        this.nbPhoto = data.length;
        this.keyTranslateNbPhoto = this.nbPhoto < 2 ? 'propertyDetails.nbPhoto' : 'propertyDetails.nbPhotoS';
        this.nbPhotoParams = { nb: this.nbPhoto };
      })
    );

    this.subs.push(
      this.vaultService.getRealPropertyDocuments(this.property.uid, null, null).subscribe((data) => {
        this.nbDoc = data.length;
        this.keyTranslateNbDoc = this.nbDoc < 2 ? 'propertyDetails.nbDoc' : 'propertyDetails.nbDocS';
        this.nbDocParams = { nb: this.nbDoc };
      })
    );
  }
}
